import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { initAuthFetch } from '@/utils/authFetch';

export function AuthInit() {
  const { instance } = useMsal();

  useEffect(() => {
    // Only pass the instance — authFetch reads the current account
    // fresh on every request so stale account references can't cause 401s
    initAuthFetch(instance);
  }, [instance]);

  return null;
}
